export default "I er blevet låst inde i et hemmeligt laboratorium og er nu ufrivilligt testpersoner i et mystisk eksperiment. Kan I undslippe?";